import { useCallback, useEffect, useState } from 'react';

const AUTO_HIDE_MS = 4000;

/**
 * UI hint for completed domains: surfaces a "click Edit to start" tooltip
 * when the user hovers the Edit button or clicks any disabled control on a
 * completed-but-not-yet-reopened domain. Auto-hides after AUTO_HIDE_MS so a
 * click-triggered hint doesn't linger.
 */
export const useEditPromptTooltip = () => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (!isOpen) return;
    const timer = setTimeout(() => setIsOpen(false), AUTO_HIDE_MS);
    return () => clearTimeout(timer);
  }, [isOpen]);

  const show = useCallback(() => setIsOpen(true), []);
  const hide = useCallback(() => setIsOpen(false), []);

  return { isOpen, show, hide };
};
